import { useContext } from 'react'

import context from '../context'

const useSelect = () => {
  return useContext(context).select
}

export default useSelect
